const React = require('react')

module.exports = { 
      attributes: {"nl":{"page_title":"Pagina niet gevonden","title":"Deze pagina is helaas niet beschikbaar","content":"Als Data Innovation Agency maken we datagedreven producten. Een goed idee voor een nieuwe webpagina is daarom altijd welkom. Neem gerust contact met ons op. In de tussentijd ben je welkom op onze homepagina.","home_page_button_title":"Naar homepagina","contact_us_button_title":"Neem contact op"},"en":{"page_title":"Page not found","title":"This page is not available","content":"As a Data Innovation Agency we make data driven products. A good idea for a new web page is therefore always welcome: feel free to contact us. In the meantime, you are welcome on our home page.","home_page_button_title":"Go to homepage","contact_us_button_title":"Contact us"}},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
});
        return markdown
      }
    ,
     }